import { render, staticRenderFns } from "./ProductSeriesList.vue?vue&type=template&id=8b2d8532&scoped=true"
import script from "./ProductSeriesList.vue?vue&type=script&lang=js"
export * from "./ProductSeriesList.vue?vue&type=script&lang=js"
import style0 from "./ProductSeriesList.vue?vue&type=style&index=0&id=8b2d8532&prod&lang=scss&scoped=true"
import style1 from "./ProductSeriesList.vue?vue&type=style&index=1&id=8b2d8532&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2d8532",
  null
  
)

export default component.exports